<div class="form-body-desktop">
  <fr-isc-form Id="service-level-deployment" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
  </fr-isc-form>
</div>
